import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const activeJob = {
  namespaced: true,
  state: {
    driverActiveJobs: []
  },
  getters,
  mutations,
  actions
}
